// D15/D23 — botão "Finalizar" da faixa do ticket. Spec vigente: docs/ticket-detail-2027/02-design/d23-v01.md + deltas d23-v02.md e
// d23-v03.md (o delta mais novo prevalece); contrato 04-php/contrato-d23.md. Base histórica: d15-v01/v02, d15-modal-v03, d15-tipo-mudou-v01/v02.
//
// - D23: o modal NÃO tem texto livre. Só o Tipo do ticket, pré-selecionado com o valor do Tipo da faixa NO CLIQUE, para o atendente
//   confirmar ou trocar. "Sem Classificação" (1) nunca é opção: o select abre em "Escolha o tipo" e o primário recusa no clique (§4.2).
// - Corpo do POST: user_id, ticket_type_id (sempre) e tipo_visto (sempre, inteiro ≥ 1: o tipo que o atendente viu ao abrir).
//   O servidor só grava o tipo do corpo quando o visto ainda é o gravado (checagem otimista, d23-v01 §6.5). Sem tipo_visto, o
//   servidor responde `desatualizado` (JS anterior à D23).
// - Estados K/L (d23-v01 §4.4): a faixa sem Select2 (lista de tipos não veio) → o tipo vem de data-tipo/data-tipo-nome do botão.
//   K (tipo > 1): select disabled com uma opção, aviso tk_fim_tipos_falha_atual, finaliza com o tipo atual.
//   L (tipo 1): select disabled em "Escolha o tipo", aviso tk_fim_tipos_falha, primário disabled e preConfirm devolve false.
// - Erro com result.tipo válido (d23-v02 §A.2): faixa mostra o tipo gravado SEM gravar (change.select2 do jQuery global; sem select,
//   o span .tk-faixa-v). Fora de K/L, o select do modal acompanha só se o atendente não mexeu. Em K, a opção única é trocada e o
//   tipoFixo acompanha (LICOES 64); id 1 leva K → L. data-tipo/data-tipo-nome do botão acompanham (atributo, nunca HTML).
// - Swal 11.10.5 (LICOES 66): o clique no confirmar desabilita os 3 botões e o hideLoading os reabilita DEPOIS que o preConfirm
//   resolve. Por isso foco e `disabled` decididos pela resposta vão num setTimeout(…, 0); o preConfirm devolve sempre o literal false
//   para manter o modal aberto (sem mensagem visível, undefined fecharia como confirmado).
// - showValidationMessage é HTML (LICOES 31): só texto fixo do idioma ou `message` do servidor (o :tipo do tipo_mudou já vem com e()).
//   result.tipo.nome é texto cru: só textContent / new Option.
// - O preConfirm NUNCA rejeita (promessa rejeitada prende o loader do Swal): tudo em try/catch. fetch próprio, fora do bt-ajax.
// - Sucesso: aplica result.elements (alvos .tk-faixa[data-ticket="N"] …), anuncia no [data-tk-faixa-status], foco na faixa, fila por
//   tkFila.receberEvento, e-mails por tkMail.receberEvento, linha do tempo. O Tipo da faixa chega pelos elements (R-F-5).
// - Textos: data-textos do botão (montado com __() no blade), lido A CADA CLIQUE; t(k) = textos[k] || k (nunca vazio).

const TEMPO_MS = 30000;
// D23 v03 §C (FAIL-02): nos primeiros 600 ms depois do clique que abre, nenhum gesto REAL fecha ou confirma o modal (duplo clique,
// tecla presa). Clique por código (Swal.clickConfirm, isTrusted false) passa sempre. Esc fica livre. Ouvintes no willOpen (LICOES 71).
const JANELA_MS = 600;
const AVISO_ETAPAS = ['interacao', 'sem_releitura', 'ja_finalizado'];
const ID_FALHA = 'tk-fim-tipo-falha';

const FaixaFinalizar = function () {

    const csrf = () => {
        const m = document.querySelector('meta[name="csrf-token"]');
        return m ? m.getAttribute('content') : (typeof CSRF_TOKEN !== 'undefined' ? CSRF_TOKEN : '');
    };
    const fmt = (s, p) => String(s).replace(/:([a-z]+)/g, (m, k) => (p && k in p ? String(p[k]) : m));   // chave inteira (:n ≠ :nome)
    // Inteiro ≥ 1 em forma canônica ('' se não for): é o que o servidor aceita em tipo_visto/ticket_type_id.
    const inteiro = (v) => { const s = String(v == null ? '' : v).trim(); return /^[1-9][0-9]*$/.test(s) ? s : ''; };

    // ---------- contexto lido NO CLIQUE (o Tipo pode ter mudado sem recarregar) ----------
    // visto: com Select2 na faixa, o valor dele (a troca pela faixa grava na hora e o data-tipo do render ficaria velho, d23-v01 §4.4);
    // sem Select2, data-tipo do botão (R-F-1). pre: valor do select do modal depois da última sincronização (§4.3).
    const contexto = (btn) => {
        let textos = {};
        try { textos = JSON.parse(btn.dataset.textos || '{}') || {}; } catch (e) { textos = {}; }
        const t = (k) => (textos[k] || k);
        const faixa = btn.closest('.tk-faixa, .tk-olho');   // D35 bloco H (H-T4): o Finalizar da 5ª janela lê o Tipo do painel
        const sel = faixa ? faixa.querySelector('select[name="ticket_type_id"]') : null;
        const doBotao = inteiro(btn.dataset.tipo);
        const c = {
            btn, t,
            id: parseInt(btn.dataset.ticket, 10) || 0,
            url: btn.dataset.url,
            user: btn.dataset.user || '',
            visto: (sel && inteiro(sel.value)) || doBotao,
            pre: '',
            semLista: !sel,     // K ou L
            bloqueado: false,   // L
            tipoFixo: '',       // K: o tipo enviado (= a opção única do select)
            nomeFixo: '',
            opcoes: sel ? Array.from(sel.options).filter(o => o.value !== '' && o.value !== '1').map(o => [o.value, o.textContent.trim()]) : [],
        };
        if (c.semLista) {
            if (doBotao && doBotao !== '1') {
                c.tipoFixo = doBotao;
                c.nomeFixo = String(btn.dataset.tipoNome || '').trim() || ('#' + doBotao);
            } else {
                c.bloqueado = true;
            }
        } else if (!c.visto) {
            c.bloqueado = true;   // inalcançável (o Select2 sempre tem um tipo); sem visto o servidor recusaria todo clique
            c.semLista = true;
        }
        return c;
    };

    // ---------- conteúdo do modal: div.tk-fim-corpo > div.tk-fim-tipo (rótulo + select [+ aviso K/L]); tudo por textContent ----------
    const blocoTipo = (c) => {
        const d = document.createElement('div');
        d.className = 'tk-fim-tipo';
        const l = document.createElement('label');
        l.setAttribute('for', 'tk-fim-tipo');
        l.textContent = c.t('tk_fim_tipo_label');
        const s = document.createElement('select');
        s.id = 'tk-fim-tipo';
        s.className = 'swal2-select';
        s.setAttribute('aria-required', 'true');
        const opcao = (v, n) => { const o = document.createElement('option'); o.value = v; o.textContent = n; s.appendChild(o); return o; };
        d.append(l, s);
        if (c.semLista) {
            // K/L: uma opção só, select disabled, aviso logo abaixo (aria-describedby).
            if (c.bloqueado) opcao('', c.t('tk_fim_tipo_vazio')); else opcao(c.tipoFixo, c.nomeFixo);
            s.disabled = true;
            const p = document.createElement('p');
            p.className = 'tk-fim-tipo-falha';
            p.id = ID_FALHA;
            p.textContent = c.t(c.bloqueado ? 'tk_fim_tipos_falha' : 'tk_fim_tipos_falha_atual');
            s.setAttribute('aria-describedby', ID_FALHA);
            d.appendChild(p);
        } else {
            opcao('', c.t('tk_fim_tipo_vazio'));
            c.opcoes.forEach(([v, n]) => { const o = opcao(v, n); if (v === c.visto) o.selected = true; });
        }
        c.pre = s.value;
        return d;
    };

    const conteudo = (c) => {
        const d = document.createElement('div');
        d.className = 'tk-fim-corpo';
        d.appendChild(blocoTipo(c));
        return d;
    };

    const Sw = () => window.Swal;
    const selTipo = () => { const h = Sw().getHtmlContainer(); return h ? h.querySelector('#tk-fim-tipo') : null; };
    const avisoTipo = () => { const h = Sw().getHtmlContainer(); return h ? h.querySelector('.tk-fim-tipo-falha') : null; };

    // Select de volta ao estado de edição depois de um erro. Em K/L ele continua disabled (FR-c do parecer-d23-design-v02).
    const restaurar = (c) => {
        const s = selTipo();
        if (s) s.disabled = !!c.semLista;
    };

    // Estado decidido pela resposta, aplicado DEPOIS do hideLoading do Swal (LICOES 66, FR-a): primário de L e foco.
    const agendar = (c, foco) => {
        setTimeout(() => {
            const Swal = Sw();
            if (!Swal.isVisible() || Swal.isLoading()) return;
            if (c.bloqueado) { const b = Swal.getConfirmButton(); if (b) b.disabled = true; }
            if (foco === 'cancelar') {
                const b = Swal.getCancelButton();
                if (b) b.focus();
            } else if (foco === 'primario') {
                // d23-v03 §D: a mensagem manda "tente de novo" → o Enter faz o que ela diz. Em L o primário está disabled: não recebe foco.
                const b = Swal.getConfirmButton();
                if (b && !b.disabled) b.focus();
            } else if (foco === 'select') {
                const s = selTipo();
                if (s && !s.disabled) s.focus();
            }
        }, 0);
    };

    // A faixa do ticket do modal mostra o tipo do servidor, sem POST do campo Tipo.
    // Select2: só o namespace `change.select2` (o selectAction está ligado em `change` sem namespace e o jQuery o filtra);
    // nunca `change` comum (gravaria de novo). jQuery GLOBAL (window.jQuery): uma 2ª instância não enxerga os handlers do Select2.
    const tipoValido = (t) => !!t && Number.isInteger(t.id) && t.id > 0 && typeof t.nome === 'string';
    const faixaTipo = (id, tipo) => {
        const faixa = document.querySelector('.tk-faixa[data-ticket="' + id + '"]');
        if (!faixa) return;
        const sel = faixa.querySelector('.tk-faixa-tipo select[name="ticket_type_id"]');
        if (sel) {
            const v = String(tipo.id);
            if (!Array.from(sel.options).some(o => o.value === v)) sel.appendChild(new Option(tipo.nome, v));   // texto como texto
            const $ = window.jQuery;
            if ($) $(sel).val(v).trigger('change.select2'); else sel.value = v;
            return;
        }
        const span = faixa.querySelector('.tk-faixa-tipo .tk-faixa-v');
        if (span) { span.textContent = tipo.nome; span.title = tipo.nome; }
    };

    const aplicarElementos = (els) => {
        (Array.isArray(els) ? els : []).forEach(e => {
            if (!e || typeof e.target !== 'string') return;
            document.querySelectorAll(e.target).forEach(alvo => { alvo.innerHTML = typeof e.html === 'string' ? e.html : ''; });
        });
    };

    // Recarrega a linha do tempo na aba (chip) ativa; resposta tardia de outro ticket não acha o mesmo nó (no-op).
    const recarregarLinhaDoTempo = () => {
        const alvo = document.getElementById('ticket-detail-timeline');
        if (!alvo) return;
        const chip = document.querySelector('.tk-tl-chips .tk-chip[aria-pressed="true"]');
        const inv = alvo.closest('[data-ajax]');
        const url = (chip && chip.dataset.ajax) || (inv && inv.dataset.ajax);
        if (!url) return;
        fetch(url, { method: 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
            .then(r => (r.ok ? r.json() : null))
            .then(d => {
                const res = d && !d.error ? d.result : null;
                if (!res || typeof res.html !== 'string' || !alvo.isConnected) return;
                // parecer-d24-front-v02 O3: o literal do catch de render (sem .tk-tl-cab) apagaria o botão "Comentário interno" (D24) até
                // reabrir o ticket; nesse caso a coluna fica como estava. Todo HTML do blade (ok, vazio, timelineErro) tem o cabeçalho.
                const tpl = document.createElement('template');
                tpl.innerHTML = res.html;
                if (!tpl.content.querySelector('.tk-tl-cab')) return;
                alvo.innerHTML = res.html;
            })
            .catch(() => { /* a linha do tempo fica como estava; o ticket já está finalizado */ });
    };

    const sucesso = (c, j) => {
        const r = (j && j.result) || {};
        aplicarElementos(r.elements);
        const faixa = document.querySelector('.tk-faixa[data-ticket="' + c.id + '"]');
        if (faixa) {
            const st = faixa.querySelector('[data-tk-faixa-status]');
            if (st) { st.textContent = ''; st.textContent = j.message || ''; }
            faixa.focus({ preventScroll: true });
        }
        if (window.tkFila && typeof window.tkFila.receberEvento === 'function') {
            window.tkFila.receberEvento('LiaTicketEvent', { ticket_id: c.id, local: true }).catch(() => {});
        }
        if (window.tkMail && typeof window.tkMail.receberEvento === 'function') {
            window.tkMail.receberEvento({ ticket_id: c.id }).catch(() => {});
        }
        if (r.timeline) recarregarLinhaDoTempo();
        if (AVISO_ETAPAS.indexOf(r.etapa) >= 0) {
            Sw().fire({ icon: 'warning', text: j.message || '', confirmButtonText: c.t('Ok') });
        }
    };

    // Erro com resposta do servidor: o que muda no modal antes da mensagem. Devolve { foco, semMensagem }.
    const aplicarErro = (c, j) => {
        const r = (j && j.result) || {};
        const s = selTipo();
        // d23-v03 §D.1 (R-D1): o foco vai para o botão que a mensagem manda usar, fora de K e em K. "Tente de novo" (validacao,
        // comunicacao, status) → primário; o que não se resolve repetindo (desatualizado, cliente, permissao, desconhecida) → Cancelar.
        // O ramo de result.tipo válido, logo abaixo, sobrescreve como na v02.
        let foco = r.etapa === 'tipo' ? (c.semLista ? 'cancelar' : 'select')
            : (['validacao', 'comunicacao', 'status'].indexOf(r.etapa) >= 0 ? 'primario' : 'cancelar');
        let semMensagem = false;
        // d23-v02 §A.2: tipo do servidor (tipo_mudou, ou o tipo já gravado nesta chamada antes de um erro).
        if (tipoValido(r.tipo) && r.etapa !== 'tipo') {
            const v = String(r.tipo.id);
            faixaTipo(c.id, r.tipo);
            c.btn.dataset.tipo = v;                // atributo: abrir de novo começa do estado gravado (I-23-9)
            c.btn.dataset.tipoNome = r.tipo.nome;
            if (c.semLista && !c.bloqueado && s && s.options.length) {
                const o = s.options[0];
                if (r.tipo.id > 1) {
                    // 3a: K com o tipo gravado; tipoFixo === S.value (LICOES 64).
                    o.value = v;
                    o.textContent = r.tipo.nome;
                    s.value = v;
                    c.tipoFixo = v;
                    c.nomeFixo = r.tipo.nome;
                } else {
                    // 3b: K → L. A mensagem do servidor manda "clicar de novo", impossível em L: sai (FR-b).
                    o.value = '';
                    o.textContent = c.t('tk_fim_tipo_vazio');
                    s.value = '';
                    c.tipoFixo = '';
                    c.bloqueado = true;
                    const p = avisoTipo();
                    if (p) p.textContent = c.t('tk_fim_tipos_falha');
                    semMensagem = true;
                }
                foco = 'cancelar';
            } else if (!c.semLista && s) {
                // Fora de K/L: o select acompanha só se o atendente não mexeu; a escolha dele nunca é sobrescrita.
                if (s.value === c.pre) {
                    if (r.tipo.id === 1) {
                        s.value = '';
                    } else {
                        if (!Array.from(s.options).some(x => x.value === v)) {
                            const n = document.createElement('option');
                            n.value = v;
                            n.textContent = r.tipo.nome;
                            s.appendChild(n);
                        }
                        s.value = v;
                    }
                }
                foco = 'select';
            }
            c.visto = v;
            if (s) c.pre = s.value;
        }
        if (r.etapa === 'status') aplicarElementos(r.elements);   // selos relidos
        return { foco, semMensagem };
    };

    const abrir = (btn) => {
        const Swal = Sw();
        if (!Swal || typeof Swal.fire !== 'function' || Swal.isVisible()) return;
        const c = contexto(btn);
        if (!c.id || !c.url) return;
        const abertoEm = performance.now();
        const naJanela = () => performance.now() - abertoEm < JANELA_MS;

        // Mensagem no modal, select restaurado, foco depois do hideLoading. Sempre o literal false (o modal fica aberto).
        // foco (d23-v03 §D): 'primario' nos erros de "tente de novo" (rede), 'cancelar' nos de sessão; todo chamador passa explícito.
        const falhar = (msg, foco) => {
            restaurar(c);
            Swal.showValidationMessage(msg);
            agendar(c, foco === undefined ? (c.semLista ? 'cancelar' : null) : foco);
            return false;
        };

        btn.setAttribute('aria-disabled', 'true');

        Swal.fire({
            title: fmt(c.t('tk_fim_titulo'), { id: c.id }),
            html: conteudo(c),
            // Coluna do grid do popup na largura cheia (.tk-fim-pop em _detail.scss, LICOES 39).
            customClass: { popup: 'tk-fim-pop' },
            showCancelButton: true,
            reverseButtons: true,
            focusCancel: c.semLista,
            confirmButtonText: c.t('tk_fim_confirmar'),
            cancelButtonText: c.t('Cancelar'),
            returnFocus: false,   // o foco é decidido no .then (botão no cancelar; faixa no sucesso)
            // O Swal chama a função a cada clique no fundo (S(t.allowOutsideClick)): o 2º clique de um duplo clique cai no container.
            allowOutsideClick: () => !Swal.isLoading() && !naJanela(),
            allowEscapeKey: () => !Swal.isLoading(),
            // d23-v03 §C.3/§A.4 + LICOES 71 (parecer-d23-front-v02 R-F1): os ouvintes que bloqueiam o 2º gesto nascem no willOpen, chamado de
            // forma SÍNCRONA dentro do Swal.fire com o popup (Nn: t.willOpen(n)). O didOpen é setTimeout, e o Chrome despacha a entrada que
            // ficou na fila antes dele: com CPU lenta, o 2º clique de um duplo clique (ou o Enter preso) chegava ao primário sem ouvinte.
            // O willOpen não roda de novo no Swal.update (o didRender rodaria).
            willOpen: (p) => {
                const popup = p || Swal.getPopup();
                // Ouvintes de CAPTURA no popup: o Swal ativa os botões por `onclick` no próprio alvo, e só a captura num ancestral roda
                // antes dele. Vivem no popup e somem com ele (cada Swal.fire cria outro container).
                const naAcao = (e) => (e.target instanceof Element ? e.target.closest('.swal2-actions button') : null);
                popup.addEventListener('click', (e) => {
                    const b = naAcao(e);
                    if (!b) return;
                    if (e.isTrusted && naJanela()) { e.preventDefault(); e.stopPropagation(); return; }
                    // Slot do anel (.swal2-loader) = largura do primário no clique, antes do onclick do Swal esconder o botão.
                    if (b.classList.contains('swal2-confirm')) popup.style.setProperty('--tk-fim-prim-w', b.getBoundingClientRect().width + 'px');
                }, true);
                // Enter preso: o keydown repetido ativaria o botão de novo (o clique vem do padrão da tecla). O Espaço ativa no keyup, que não repete.
                popup.addEventListener('keydown', (e) => {
                    if (e.repeat && e.key === 'Enter' && naAcao(e)) { e.preventDefault(); e.stopPropagation(); }
                }, true);
            },
            // Foco e aria-live continuam no didOpen (d23-v03 §D.1; parecer-d23-front-v02 R-F1 manda manter).
            didOpen: () => {
                const vm = Swal.getValidationMessage();
                if (vm) vm.setAttribute('aria-live', 'assertive');
                if (c.semLista) {
                    if (c.bloqueado) { const b = Swal.getConfirmButton(); if (b) b.disabled = true; }
                    const cb = Swal.getCancelButton();
                    if (cb) cb.focus();
                } else {
                    const s = selTipo();
                    if (s) s.focus();
                }
            },
            showLoaderOnConfirm: true,
            // Cadeia de promessas (sem async/await: nenhum código 2027 usa, e o bundle não traz regenerator). NUNCA rejeita.
            preConfirm: () => {
                if (c.bloqueado) { agendar(c, 'cancelar'); return false; }   // L: 2ª trava (o primário já está disabled)
                const s = selTipo();
                const tipo = inteiro(c.semLista ? c.tipoFixo : (s ? s.value : ''));
                if (!tipo || tipo === '1') return falhar(c.t('tk_fim_erro_tipo'), c.semLista ? 'cancelar' : 'select');   // sem requisição
                if (s) s.disabled = true;
                const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
                const relogio = ctrl ? setTimeout(() => ctrl.abort(), TEMPO_MS) : null;
                const fim = () => { if (relogio) clearTimeout(relogio); };
                const corpo = new URLSearchParams();
                corpo.set('user_id', c.user);
                corpo.set('ticket_type_id', tipo);
                corpo.set('tipo_visto', c.visto);
                let req;
                try {
                    req = fetch(c.url, {
                        method: 'POST', body: corpo, credentials: 'same-origin',
                        headers: { 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
                        signal: ctrl ? ctrl.signal : undefined,
                    });
                } catch (e) {
                    fim();
                    return falhar(c.t('tk_fim_erro_rede'), 'primario');
                }
                return req.then((r) => {
                    if (r.status === 419 || r.redirected) return falhar(c.t('tk_fim_erro_sessao'), 'cancelar');
                    if (!r.ok) return falhar(c.t('tk_fim_erro_rede'), 'primario');
                    if ((r.headers.get('content-type') || '').indexOf('json') < 0) return falhar(c.t('tk_fim_erro_sessao'), 'cancelar');
                    return r.json().then((j) => {
                        if (!j || typeof j !== 'object') return falhar(c.t('tk_fim_erro_rede'), 'primario');
                        if (j.error) {
                            const pos = aplicarErro(c, j);
                            if (pos.semMensagem) {
                                // K → L (d23-v02 §A.2 3b): nenhuma mensagem do servidor; o reset vem por último (FR-b).
                                restaurar(c);
                                Swal.resetValidationMessage();
                                agendar(c, 'cancelar');
                                return false;
                            }
                            return falhar(j.message || c.t('tk_fim_erro_rede'), pos.foco);
                        }
                        return j;   // fecha o modal; segue no .then
                    });
                }).catch(() => falhar(c.t('tk_fim_erro_rede'), 'primario'))   // rede, AbortError, JSON inválido
                  .then((v) => { fim(); return v; }, () => { fim(); return false; });
            },
        }).then((res) => {
            if (btn.isConnected) btn.removeAttribute('aria-disabled');
            if (res && res.isConfirmed && res.value && typeof res.value === 'object') {
                sucesso(c, res.value);
            } else if (btn.isConnected) {
                btn.focus({ preventScroll: true });
            }
        }).catch(() => {
            if (btn.isConnected) btn.removeAttribute('aria-disabled');
        });
    };

    return {
        init: function () {
            document.addEventListener('click', (e) => {
                const btn = e.target instanceof Element ? e.target.closest('.tk-faixa .tk-faixa-fim, .tk-olho .tk-olho-fim') : null;   // D35 bloco H (H-T4)
                if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
                e.preventDefault();
                abrir(btn);
            });
            window.tkFaixa = { tipo: faixaTipo };   // D35 bloco H (H-T3): o Tipo mudado na 5ª janela do ticket aberto sincroniza o oculto da barra
        },
    };
}();

module.exports = FaixaFinalizar;
